// Generated by @hypernym/nuxt-gsap
import { defineNuxtPlugin } from '#app';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { TextPlugin } from 'gsap/TextPlugin';
import { ExpoScaleEase } from 'gsap/EasePack';
import { RoughEase } from 'gsap/EasePack';
import { SlowMo } from 'gsap/EasePack';
const plugin = defineNuxtPlugin(() => {
  if(process.client) {
  gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,TextPlugin,ExpoScaleEase,RoughEase,SlowMo);
  
  
}
  return {
    provide: {
      gsap,
      ScrollTrigger,
ScrollToPlugin,
TextPlugin,
ExpoScaleEase,
RoughEase,
SlowMo
    }
  }
})
export default plugin;